import {
  GET_COUNTRIES,
  GET_COUNTRIES_FAIL,
  GET_COUNTRIES_SUCCESS,
  GET_CITIES_BY_COUNTRY,
  GET_CITIES_BY_COUNTRY_FAIL,
  GET_CITIES_BY_COUNTRY_SUCCESS,
} from "./actionTypes"

export const getCountries = () => ({
  type: GET_COUNTRIES,
})

export const getCountriesSuccess = admins => ({
  type: GET_COUNTRIES_SUCCESS,
  payload: admins,
})

export const getCountriesFail = error => ({
  type: GET_COUNTRIES_FAIL,
  payload: error,
})

export const getCitiesByCountry = (id) => ({
  type: GET_CITIES_BY_COUNTRY,
  payload:id
})

export const getCitiesByCountrySuccess = admins => ({
  type: GET_CITIES_BY_COUNTRY_SUCCESS,
  payload: admins,
})

export const getCitiesByCountryFail = error => ({
  type: GET_CITIES_BY_COUNTRY_FAIL,
  payload: error,
})


